import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import ModulesStateAdminMylist from './Modules.State.adminmylist'; 
import ModulesStatePlatform from './Modules.State.platform';
import ModulesStateWaitingjoin from './Modules.State.waitingjoin';
import ModulesStateUserlist from './Modules.State.userlist'; 

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** tab path key */
    public tabchange: string = '1';
    /** 国家列表 */
    public countryList: {
        code: string;
        name: string;
    }[] = [];
    /** 城市列表 */
    public cityList: {
        code: string;
        name: string;
        stateCode: string;
    }[] = [];
    /** 临时存储备注信息 */
    /** 确认上传 */
    // public sendupload = false;
    public remarkTemp: string = '';
    /** 备注框可否被编辑 */
    public visibleWrite: boolean = false;
    /*** 备注被编辑的conntectid,有值表示可编辑 */
    public visibleWriteConnectionId: string = '';
    /** 状态 */
    public connectionState: number = 0;
    /** 模糊查询城市列表 */
    public cityVagueData: any[] = [];
    /** 详情显示拒绝按钮 */
    public isShowRefuseId: string = '';
    /** 模糊查询公司名称，状态:是否注册 */
    public companyVagueData: any[] =[];
    /** 上传文件列表 */
    public fileList: any[] = [];
    /** 显示连接（邀请里面，输入公司名字模糊查询，用户从中选中数据，按钮出现连接） */
    public showLinkButtonDetail: any;
    /** 是否点击合并展开按钮，我的网络 */
    public waitinglistshow: boolean = true;
    /** 用户列表，我的网络，待加入公司，不分页 */
    public stateUserWaitingjoinlist = [];
    /*** 网络管理，我的网络 */
    public stateMylist = new ModulesStateAdminMylist();  
    /*** 网络管理，网络平台 */
    public statePlatform = new ModulesStatePlatform();  
    /*** 待加入 */
    public stateWaitingjoin = new ModulesStateWaitingjoin(); 
    /*** 用户列表，我的网络 */
    public stateUserlist = new ModulesStateUserlist(); 
    /** 用户详情公司代码是否可编辑 */
    public companyCodeEdit: boolean = false;
    public companyCodeTemp: string = '';

    /** 公共链接弹框是否显示 */
    public publicLinksModalVisible: boolean = false;
    /** 公共邀请链接 */
    public publicLinkTicket: string = '';

    /** 公司风采弹框--展示图片 */
    public showEleganceModal: boolean = false;
    public imgUrlElegance: string = '';
    public imgList: Array<any> = [];
    /** 标签数据 */
    public tagData: any[];
    /** 公司标签 */
    // public CompanyTagData: any[];
    /** 是否可编辑 */
    public visiblelabels: boolean;
    /** 是否显示城市搜索框 */
    public showCityComp: boolean = false;
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/Modules.State.ts